export const DOWNLOAD_APP_EVENTS = {
  VIEW_DOWNLOAD_APP: 'view_onboarding_completed',
  SELECT_DOWNLOAD_APP: 'select_onboarding_completed_download_app',
  SELECT_OPEN_MODAK_REGISTER: 'select_onboarding_completed_open_modak_register',
  SELECT_OPEN_MBX_POLICY: 'select_onboarding_completed_open_mbx_policy',
  VIEW_AUTHENTICATION_DOWNLOAD_APP: 'view_authentication_download_app',
  SELECT_AUTHENTICATION_DOWNLOAD_APP: 'select_authentication_download_app',
} as const;
